export default "__VITE_ASSET__B1V7Mg_8__"